var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard-wrapper"},[(!_vm.showNewVersion)?_c('div',{staticClass:"old-version-wrapper"},[_c('DashboardOld')],1):_c('DashboardNew',{on:{"switchVersion":function($event){_vm.showNewVersion = false}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }